import { render } from "./IconCheckChildren.vue?vue&type=template&id=0bf1dfc2"
import script from "./IconCheckChildren.vue?vue&type=script&lang=ts"
export * from "./IconCheckChildren.vue?vue&type=script&lang=ts"
script.render = render

export default script